import React, { FC } from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import { useFormat } from 'helpers/hooks/useFormat';
import Image, { ImageProps } from 'frontastic/lib/image';
import { SocialMedia } from '.';
import { StaticImageData } from 'next/image';
import { Reference } from 'types/reference';
import MarketButton from '../market-button/market-button';

interface Props {
  socialMedia?: any;
  copyright?: any;
}

const FooterBottom: FC<Props> = ({ socialMedia, copyright }) => {
  const { formatMessage } = useFormat({ name: 'common' });

  return (
    <>
      {/* Comment all the social media icons from footer because we will going to show these icons with "Follow Us"
      This logic will be same for both Australia and NewZealand */}
      
      <div className="hidden items-center justify-between py-36 md:flex xl:pb-24 xl:pt-64">
        <Typography className="pb-40 text-14 text-neutral-500 md:text-12 2xl:text-14 mt-20">
          {copyright?.children?.[0]?.children?.[0]?.text}
        </Typography>
        <div className='flex justify-center gap-48'>
          <MarketButton />
          {/* <ul className="flex flex-row gap-12 self-center 2xl:gap-20">
            {socialMedia?.map(
              (
                item: {
                  url: { href: string | Reference | undefined };
                  icon: { url: string | StaticImageData | undefined };
                },
                i: string | number | null | undefined,
              ) => (
                <li key={i} className="w-20 2xl:w-24">
                  <Link link={item?.url?.href}>
                    <Image src={item?.icon?.url} className="mb-20" height={24} width={24} />
                  </Link>
                </li>
              ),
            )}
          </ul> */}
        </div>
      </div>


      <div className="flex flex-col items-start pt-48 md:hidden">
        <div className='flex items-center w-full flex-col gap-24'>
        {/* Comment all the social media icons from footer because we will going to show these icons with "Follow Us"
        This logic will be same for both Australia and NewZealand */}
        <MarketButton/>
        {/* <ul className="mb-6 flex w-full flex-row items-center justify-center gap-20">
          {socialMedia?.map(
              (
              item: {
                  url: { href: string | Reference | undefined };
                  icon: { url: string | StaticImageData | undefined };
                },
              i: string | number | null | undefined,
              ) => (
                  <li key={i} className="w-28">
                <Link link={item?.url?.href}>
                  <Image src={item?.icon?.url} className="mb-16" height={28} width={28} />
                </Link>
              </li>
            ),
            )}
        </ul> */}
        </div>

        <Typography className="pb-10 text-14 text-neutral-500 mt-20">
          {copyright?.children?.[0]?.children?.[0]?.text}
        </Typography>
      </div>
    </>
  );
};

export default FooterBottom;
